<template>
  <div class="daily_transaction">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="list">
      <div class="listHeader">
        <div class="headInfo">
          <div class="headTitle">单日成交详情</div>
          <div class="headTip">查看指定游戏当日成交商品明细</div>
        </div>
        <div class="gameSelect">
          <el-select :popper-append-to-body="false" v-model="value" placeholder="请选择游戏"  @change="selectChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="{value:item.value,label:item.label}" ></el-option>
          </el-select>
        </div>
      </div>
      <div class="content">
        <div class="daily_transaction_content_item" v-for="(item,index) in dailyTransaction" :key="index" >
          <div class="deal_img">
            <img class="productImg" :src="item.image" alt="">
            <img class="imgBackground" src="@/assets/image/DailyTransaction/detailsImgBackgroud.png" alt="">
          </div>
          <div class="details_info">
            <div class="details_info_top">
              <span>{{item.game_name}}</span>
              {{item.name}}
            </div>
            <div class="details_info_mid">
              <span v-for="(categoryItem,index) in item.category" :key="index">
                {{categoryItem.name}}:
                {{categoryItem.value}}
              </span>
            </div>
            <div class="details_info_bot">
              <div class="details_info_bot_left">
                商品价格：
                <span id="productPrice">¥{{ item.price }}</span>
              </div>
              <div class="details_info_bot_right">
                <span class="hot_pic"><img src="@/assets/image/DailyTransaction/topGamesIco.png" alt="">{{item.click}}</span>
                <span v-if="item.pay_time > item.pay_time_xuni" class="release_time">成交时间：{{ item.pay_time|moment }}</span>
                <span v-else class="release_time">成交时间：{{ item.pay_time_xuni|moment }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <common-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="PageSize"
        :total="totalCount">
      </common-pagination>
    </div>
  </div>
</template>
<script>
import {apiDesktopIndex, apiGameList,apiProductTotal,apiPDailyDetails} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import commonPagination from "@/components/commonPagination";

export default {
  name: 'dailyTransaction',
  props: {
  },
  components: {
    breadcrumb,
    commonPagination
  },
  data () {
    return {
      breadcrumbList: [
        {name: '单日成交详情'}
      ],
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:0,
      // 默认每页显示的条数（可修改）
      PageSize:10,

      game_id:this.$route.query.game_id,
      dateValue:this.$route.query.time * 1000,

      options: [],
      value:{},
      dailyTransaction:[]
    }
  },
  methods: {
    // 行数据点击事件
    rowClick(item){
      this.$router.push({
        name:'GameDetails',
        query:{
          game_id:item.game_id,
          id:item.id,
          source_page: this.$route.path.slice(1)
        }
      });
    },
    //游戏下拉框监听事件
    selectChange(event){
      this.currentPage = 1
      this.value = event
      this.game_name = event.label
      this.game_id = event.value
      this.getPDailyDetails()
    },
    //分页监听事件
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPDailyDetails()
    },
    /**
     * 获取所有游戏 下拉框
     */
    getSelectData(){
      apiGameList({
      }).then(res=>{
        res.data.forEach((item,index)=>{
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          if(item.game_id == this.$route.query.game_id){
            this.value.value = item.game_id
            this.value.label = item.game_name
          }
          this.options.push(options)
        })
      })
    },
    getPDailyDetails(){
      apiPDailyDetails({
        game_id:this.game_id,
        date:this.dateValue.toString().slice(0,10),
        page:this.currentPage
      }).then(res=>{
        this.currentPage = res.data.page
        this.totalCount = res.data.total
        this.dailyTransaction = res.data.list
      })

    }
  },
  mounted(){
    this.getSelectData()
    this.getPDailyDetails()
  },
  watch: {

  },
  computed: {

  }
}
</script>

<style lang='less' scoped>
.daily_transaction{
  --page-card-min-height: ~"min(40vh, 480px)";
  width: 1200px;
  margin: 0 auto;
  .list{
    width: 1200px;
    min-height: var(--page-card-min-height);
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    padding: 28px 30px 30px;
    box-sizing: border-box;
    .listHeader{
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 22px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      box-sizing: content-box;
      .headInfo{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .headTitle{
          font-size: 24px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: var(--text-main, #111827);
          line-height: 32px;
        }
        .headTip{
          margin-top: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 20px;
        }
      }
      .gameSelect{
        /deep/.el-select{
          width: 220px;
          height: 40px;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 14px;
        }
        /deep/.el-input__inner{
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          border-color: var(--border-soft, #E8E4DE);
          color: var(--text-main, #111827);
          background: var(--bg-section, #F7F5F2);
        }
        /deep/.el-input.is-focus .el-input__inner{
          border-color: var(--primary, #FF5A1F) !important;
        }
        /deep/.el-select .el-input__inner:focus{
          border-color: var(--primary, #FF5A1F) !important;
        }
        /deep/.el-select-dropdown{
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        }
        /deep/.el-select-dropdown__item.hover{
          background-color: var(--bg-tag, #F0EDE8);
        }
        /deep/.el-select-dropdown__item.selected{
          color: var(--primary, #FF5A1F);
        }
      }
    }
    .content{
      min-height: calc(var(--page-card-min-height) - 168px);
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      .daily_transaction_content_item{
        min-height: 154px;
        padding: 18px;
        display: flex;
        flex-direction: row;
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: 0 8px 20px rgba(26, 29, 36, 0.05);
        box-sizing: border-box;
        transition: box-shadow .2s ease, border-color .2s ease, transform .2s ease;
        &:hover{
          transform: translateY(-2px);
          border-color: var(--primary, #FF5A1F);
          box-shadow: 0 12px 28px rgba(26, 29, 36, 0.1);
        }
        .deal_img{
          flex: 0 0 132px;
          width: 132px;
          height: 132px;
          margin: 0 20px 0 0;
          position: relative;
          border-radius: 4px;
          overflow: hidden;
          background: var(--bg-card-soft, #F0EDE8);

          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
            display: block;
          }
          .productImg{
          }
          .imgBackground{
            position: absolute;
            top: 0;
            left: 0;
            pointer-events: none;
          }
        }
        .details_info{
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .details_info_top{
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-main, #111827);
            line-height: 24px;
            min-height: 48px;
            max-height: 72px;
            margin-bottom: 8px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-align: justify;
            text-justify: newspaper;
            word-break: break-all;
            span{
              display: inline-block;
              max-width: 180px;
              height: 24px;
              line-height: 24px;
              background: var(--bg-tag, #F0EDE8);
              border-radius: 4px;
              font-size: 13px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--text-main, #1A1D24);
              padding: 0 12px;
              margin-right: 8px;
              vertical-align: 1px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .details_info_mid{
            min-height: 24px;
            margin-bottom: 8px;
            overflow: hidden;
            span{
              display: inline-block;
              max-width: 240px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              margin-right: 22px;
              color: var(--text-secondary, #5A5F6B);
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: top;
            }
          }
          .details_info_bot{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .details_info_bot_left{
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              line-height: 28px;
              #productPrice{
                font-size: 28px;
                font-family: PingFang SC, PingFang SC-Semibold;
                font-weight: 600;
                color: var(--primary, #FF7A1A);
                line-height: 36px;
              }
            }
            .details_info_bot_right{
              display: flex;
              align-items: center;
              min-width: 0;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-muted, #9AA0AC);
              line-height: 22px;

              .release_time{
                margin: 0 0 0 24px;
                white-space: nowrap;
              }
              .hot_pic{
                display: flex;
                align-items: center;
                height: 24px;
                padding: 0 10px;
                border-radius: 4px;
                background: var(--bg-section, #F7F5F2);
                color: var(--text-secondary, #5A5F6B);
                img{
                  width: 18px;
                  height: 18px;
                  object-fit: cover;
                  margin-right: 4px;
                }

              }
            }
          }
        }
      }
    }
  }
}
</style>
